/**
 * As prismisc-javascript@<=4.x.x isn't bundled well (there only one file which contains all dependencies),
 * has typing issue and doesn't export reference on the default cache api: we need wrappers in this file
 * to expose a clean api.
 */
type PrismicJSModule = typeof import('prismic-javascript')['default'];

// eslint-disable-next-line @typescript-eslint/no-var-requires
export const PrismicJS: PrismicJSModule = require('prismic-javascript').default || require('prismic-javascript');
